var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-tooltip-status-label my-1"},[_c('v-chip',{staticClass:"mr-2",attrs:{"label":"","x-small":"","dark":_vm.boxDark,"outlined":_vm.boxOutlined,"color":_vm.boxColor}},[_vm._v(" "+_vm._s(_vm.statusLabel)+" ")]),_c('span',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }